var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconuser = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.93945 10.1888C8.04883 10.1888 7.26953 10.0033 6.52734 9.55798C5.78516 9.14978 5.22852 8.59314 4.82031 7.85095C4.375 7.10876 4.18945 6.32947 4.18945 5.43884C4.18945 4.58533 4.375 3.80603 4.82031 3.06384C5.22852 2.32166 5.78516 1.76501 6.52734 1.3197C7.26953 0.911499 8.04883 0.688843 8.93945 0.688843C9.79297 0.688843 10.5723 0.911499 11.3145 1.3197C12.0566 1.76501 12.6133 2.32166 13.0586 3.06384C13.4668 3.80603 13.6895 4.58533 13.6895 5.43884C13.6895 6.32947 13.4668 7.10876 13.0586 7.85095C12.6133 8.59314 12.0566 9.14978 11.3145 9.55798C10.5723 10.0033 9.79297 10.1888 8.93945 10.1888ZM12.2793 11.3763C13.1699 11.3763 13.9863 11.599 14.7656 12.0443C15.5078 12.4896 16.1387 13.1205 16.584 13.8627C17.0293 14.642 17.252 15.4584 17.252 16.349V17.9076C17.252 18.4271 17.0664 18.8353 16.7324 19.1693C16.3613 19.5404 15.9531 19.6888 15.4707 19.6888H2.4082C1.88867 19.6888 1.48047 19.5404 1.14648 19.1693C0.775391 18.8353 0.626953 18.4271 0.626953 17.9076V16.349C0.626953 15.4584 0.849609 14.642 1.29492 13.8627C1.74023 13.1205 2.33398 12.4896 3.11328 12.0443C3.85547 11.599 4.70898 11.3763 5.59961 11.3763H6.23047C7.08398 11.7845 7.97461 11.9701 8.93945 11.9701C9.86719 11.9701 10.7578 11.7845 11.6484 11.3763H12.2793Z",
    fill: "#413E3F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconuser);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.user.7b7142d2878f72ab200ef26c129e1802.svg";